import {
	Object3D,
	MeshStandardMaterial,
	Mesh,
	Vector2,
	CircleGeometry,
} from 'three';

export abstract class RenderUtils {
	static disposeObject(object: Object3D) {
		object.traverse((object) => {
			if (RenderUtils.isMesh(object)) {
				if (object.geometry) object.geometry.dispose();

				if (object.material) {
					if (Array.isArray(object.material)) {
						object.material.forEach((material) => material.dispose());
					} else {
						object.material.dispose();
					}
				}
			}
		});

		object.clear();
		if (object.parent) object.parent.remove(object);
	}

	static disposeMaterial(object: Object3D) {
		if (!RenderUtils.isMesh(object)) return;

		if (Array.isArray(object.material)) {
			for (const material of object.material) {
				const mat = material as MeshStandardMaterial;

				mat.dispose();
				mat.map?.dispose();
				mat.normalMap?.dispose();
				mat.roughnessMap?.dispose();
				mat.metalnessMap?.dispose();
			}
		} else {
			const mat = object.material as MeshStandardMaterial;

			mat.dispose();
			mat.map?.dispose();
			mat.normalMap?.dispose();
			mat.roughnessMap?.dispose();
			mat.metalnessMap?.dispose();
		}
	}

	static isMesh(object: Object3D): object is Mesh {
		return object instanceof Mesh;
	}

	static computePolygonArea(vertices: Vector2[]) {
		let area = 0;
		const n = vertices.length;

		for (let i = 0; i < n; i++) {
			const current = vertices[i];
			const next = vertices[(i + 1) % n];
			area += current.x * next.y - next.x * current.y;
		}

		return Math.abs(area) / 2;
	}

	static ccw(a: Vector2, b: Vector2, c: Vector2) {
		return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
	}

	static generateCircleUVs(geometry: CircleGeometry, radius: number) {
		const scale = radius * 2;

		const uvs = geometry.attributes.uv;
		for (let i = 0; i < uvs.count; i++) {
			const x = uvs.getX(i);
			const y = uvs.getY(i);

			uvs.setXY(i, x * scale, y * scale);
		}
	}
}
